/**
 * Pick catalog / store subscription id for ratings & review `offeringId`.
 * Enrollment id is excluded when the payload provides a distinguishable catalog id.
 */
export function resolveStoreSubscriptionIdForReviews(
  o: Record<string, unknown>,
  enrollmentId: number
): number {
  function num(v: unknown): number | undefined {
    if (typeof v === "number" && Number.isFinite(v)) {
      return v;
    }
    if (typeof v === "string" && v.trim() !== "") {
      const n = Number(v);
      return Number.isFinite(n) ? n : undefined;
    }
    return undefined;
  }

  /**
   * Customer subscription list/detail payloads use `id` for the purchase row and
   * `subscriptionId` for the catalog/store offering id (reviews expect the latter).
   */
  const fromRootSubscriptionId = num(o.subscriptionId ?? o.subscription_id);
  if (fromRootSubscriptionId !== undefined && fromRootSubscriptionId > 0) {
    return fromRootSubscriptionId;
  }

  const nestedSubscription =
    o.subscription && typeof o.subscription === "object"
      ? (o.subscription as Record<string, unknown>)
      : null;
  const nestedIdRaw = nestedSubscription?.id;
  const fromNested = nestedIdRaw !== undefined ? num(nestedIdRaw) : undefined;
  const fromOffer = num(
    o.offeringId ??
      o.offering_id ??
      o.storeSubscriptionId ??
      o.store_subscription_id ??
      o.catalogSubscriptionId ??
      o.catalog_subscription_id
  );

  if (fromNested !== undefined) {
    return fromNested;
  }
  if (fromOffer !== undefined) {
    return fromOffer;
  }
  return enrollmentId > 0 ? enrollmentId : 0;
}
